


















import {computed, defineComponent, PropType} from "@vue/composition-api";
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import moment from "moment";
import {DateRangeInterface, VCalendarDateRangeInterface} from "@tool/Pages/App/Project/Reports/reports.types";

interface PredefinedRange {
    name: string,
    range: () => DateRangeInterface<Date>
}

export default defineComponent({
    components: {
        DatePicker
    },
    props: {
        value: {
            type: Object as PropType<DateRangeInterface<string>>,
            required: true
        }
    },
    setup(props, {emit}) {

        const localValue = computed<VCalendarDateRangeInterface>({
            get() {
                return {
                    start: moment(props.value.from).toDate(),
                    end: moment(props.value.to).toDate(),
                }
            },
            set(newValue: VCalendarDateRangeInterface) {
                changeRange({
                    from: newValue.start,
                    to: newValue.end
                });
            }
        });

        const predefinedRanges: PredefinedRange[] = [
            {
                name: 'Today',
                range: () => {
                    let today = new Date();
                    return {
                        from: today,
                        to: today
                    }
                }
            },
            {
                name: 'Yesterday',
                range() {
                    let yesterday = moment().subtract(1, 'day').toDate();
                    return {
                        from: yesterday,
                        to: yesterday
                    }
                }
            },
            {
                name: 'Last 7 days',
                range() {
                    return {
                        from: moment().subtract(6, 'days').toDate(),
                        to: new Date()
                    }
                }
            },
            {
                name: 'Last 30 days',
                range() {
                    return {
                        from: moment().subtract(29, 'days').toDate(),
                        to: new Date()
                    }
                }
            },
            {
                name: 'This month',
                range() {
                    return {
                        from: moment().startOf('month').toDate(),
                        to: new Date()
                    }
                }
            },
            {
                name: 'Last month',
                range() {
                    let lastMonthDate = moment().subtract(1, 'month');
                    return {
                        from: lastMonthDate.startOf('month').toDate(),
                        to: lastMonthDate.endOf('month').toDate()
                    }
                }
            },
            {
                name: 'Last 3 months',
                range() {
                    let threeMonthsAgo = moment().subtract(3, 'month');
                    let lastMonthDate = moment().subtract(1, 'month');
                    return {
                        from: threeMonthsAgo.startOf('month').toDate(),
                        to: lastMonthDate.endOf('month').toDate()
                    }
                }
            },
            // {
            //     name: 'Last 6 months',
            //     range: this.localValue
            // },
            // {
            //     name: 'This year',
            //     range: this.localValue
            // },
            // {
            //     name: 'All time',
            //     range: this.localValue
            // }
        ];

        const minDate = moment().subtract(90, 'days').toDate();
        const maxDate = moment().toDate();

        const formatRange = (range: DateRangeInterface<string | Date>) => {
            return `${moment(range.from).format('ll')} - ${moment(range.to).format('ll')}`
        }
        const buttonText = computed(() => {
            return formatRange(props.value);
        });

        const changeRange = (range: DateRangeInterface<string | Date>) => {
            emit('update:value', range);
        }

        return {
            localValue,
            predefinedRanges,
            minDate,
            maxDate,
            buttonText,
            formatRange,
            changeRange,
        }
    }
})
